/**
 * Make first letter of a string upper case
 * @param string
 */
export default function capitalizeFirstLetter(string: string): string | boolean {
  if (!string) return false
  return string.trim().charAt(0).toUpperCase() + string.trim().slice(1)
}
